import { IconClose16, ModalFullscreen } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './TourModalMobile.css';
import { TourWidget } from '../TourWidget';
import { GalleryFooterMobile } from '../GalleryFooterMobile';
import { GalleryInfoMobile } from '../GalleryInfoMobile';

interface ITourModalMobileProps {
  tourUrl: string;
  projectName: string;
  factoids: string;
  phoneButton: React.ReactNode;
  callbackButton: React.ReactNode;
  onClose(): void;
}

export const TourModalMobile: React.FC<ITourModalMobileProps> = ({
  tourUrl,
  phoneButton,
  callbackButton,
  projectName,
  factoids,
  onClose,
}) => {
  return (
    <ModalFullscreen theme="black" open={true} onClose={onClose}>
      <div className={styles['container']} data-name="TourModalMobile">
        <div className={styles['close-button']} onClick={onClose}>
          <IconClose16 color="white_100" />
        </div>
        <div className={styles['tour']}>
          <TourWidget url={tourUrl} />
        </div>
        <GalleryFooterMobile
          info={<GalleryInfoMobile name={projectName} factoids={factoids} />}
          actions={[phoneButton, callbackButton]}
        />
      </div>
    </ModalFullscreen>
  );
};
